// resolve-claude-code-alias-to-bare-model-env.ts
//
// Cơ chế "ALIAS = SLOT TIER" — env expand alias → model user đã map.
//
// Bối cảnh (verify 2026-06-11 sniffer + 2026-06-12 bug deepseek, CC 2.1.x):
//   Param `model` của Agent tool là ENUM CỨNG chỉ nhận alias (sonnet|opus|haiku|
//   fable) — KHÔNG nhận tên model đầy đủ. Truyền "deepseek-v4-flash" (hay cả
//   "claude-opus-4-8") đều không hợp lệ → Claude tự thế alias gần nhất (sai model).
//   Claude Code expand alias → ID nội bộ HARDCODED (vd haiku →
//   claude-haiku-4-5-20251001 dated → gateway NAL 403), NHƯNG ưu tiên env:
//     function xT6(){ if(process.env.ANTHROPIC_DEFAULT_HAIKU_MODEL) return ...; }
//
// Giải pháp: coi 3 alias là 3 SLOT TIER, ghi env TỪ CHÍNH BẢNG MAP user chọn:
//     ANTHROPIC_DEFAULT_OPUS_MODEL   = map.hard      (lệnh hard-task   spawn model="opus")
//     ANTHROPIC_DEFAULT_SONNET_MODEL = map.standard  (lệnh normal-task spawn model="sonnet")
//     ANTHROPIC_DEFAULT_HAIKU_MODEL  = map.fast      (lệnh easy-task   spawn model="haiku")
//   → alias expand thành đúng model user map, BẤT KỂ provider (claude-*,
//   deepseek-*, ...). Đồng thời fix luôn 403 dated-ID (env ghi đè dated default).
//
// KHÔNG hardcode model ID: map đến từ /v1/models thật user chọn lúc enable.

// Map tier → env slot alias tương ứng (đồng bộ với commands/avatar/savecost/*).
export interface ModelTierMapLike {
  hard: string;
  standard: string;
  fast: string;
}

// Trả về map { envVar → model ID } để merge vào settings.json env.
export function resolveTierSlotModelEnv(map: ModelTierMapLike): Record<string, string> {
  return {
    ANTHROPIC_DEFAULT_OPUS_MODEL: map.hard,
    ANTHROPIC_DEFAULT_SONNET_MODEL: map.standard,
    ANTHROPIC_DEFAULT_HAIKU_MODEL: map.fast,
  };
}
